/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Rail_FindInputs */

const en_how_page_rail_find = /** @type {(inputs: How_Page_Rail_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find`)
};

const pl_how_page_rail_find = /** @type {(inputs: How_Page_Rail_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź`)
};

/**
* | output |
* | --- |
* | "Find" |
*
* @param {How_Page_Rail_FindInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_rail_find = /** @type {((inputs?: How_Page_Rail_FindInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Rail_FindInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_rail_find(inputs)
	return en_how_page_rail_find(inputs)
});